import { Reveal } from "@/components/common/Reveal";

const PRINCIPLES = [
  { label: "Understand", body: "We start with the actual need." },
  { label: "Shape", body: "We determine the right approach." },
  { label: "Deliver", body: "We turn the solution into something useful." },
];

export const WhySCC = () => (
  <section className="border-t border-border bg-blue-50 py-24 lg:py-32" data-testid="why-scc">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="max-w-3xl">
        <h2 className="font-heading text-3xl font-extrabold tracking-tight text-slate-900 md:text-4xl lg:text-5xl">
          The right solution starts with understanding.
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-slate-600">
          SCC starts with what you're trying to achieve, not with a predefined service. We
          understand the requirement, identify what actually needs to be done, and bring the
          right capability to the problem.
        </p>
      </Reveal>

      <div className="mt-16 grid gap-10 border-t border-border pt-12 sm:grid-cols-3 sm:gap-0">
        {PRINCIPLES.map((p, i) => (
          <Reveal
            key={p.label}
            delay={i * 0.08}
            className="sm:border-l sm:border-border sm:pl-10 sm:first:border-l-0 sm:first:pl-0"
            data-testid={`principle-${p.label.toLowerCase()}`}
          >
            <span className="text-sm font-semibold uppercase tracking-[0.22em] text-blue-600">
              {p.label}
            </span>
            <p className="mt-4 font-heading text-xl font-bold leading-snug tracking-tight text-slate-900 md:text-2xl">
              {p.body}
            </p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
